import { render, staticRenderFns } from "./DetailLeft.vue?vue&type=template&id=af3c97f6&scoped=true&"
import script from "./DetailLeft.vue?vue&type=script&lang=js&"
export * from "./DetailLeft.vue?vue&type=script&lang=js&"
import style0 from "./DetailLeft.vue?vue&type=style&index=0&id=af3c97f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3c97f6",
  null
  
)

export default component.exports